import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { ContextMenuTrigger } from 'react-contextmenu';

/**
 * AG-Grid cell renderer that opens the table context menu on right click.
 *
 * @param {object} props Props.
 * @param {*} props.value Cell value, rendered when no children are passed.
 * @param {object} props.data Row data, passed to the context menu as `rowData`.
 * @param {object} props.colDef Column definition with the context menu id.
 * @param {React.ReactNode} props.children Custom cell content.
 */
const ContextMenuCellRendererComponent = ({ value, data, colDef, children }) => {
  const collect = useCallback(() => ({ rowData: data }), [data]);

  return (
    <ContextMenuTrigger collect={collect} id={colDef.contextMenuId}>
      {children || value}
    </ContextMenuTrigger>
  );
};

ContextMenuCellRendererComponent.propTypes = {
  children: PropTypes.node,
  colDef: PropTypes.shape({ contextMenuId: PropTypes.string.isRequired }).isRequired,
  data: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

export const ContextMenuCellRenderer = memo(ContextMenuCellRendererComponent);
